import * as React from 'react'
import { useEventListener } from './EventListener'

export interface ClickOutsideConfig {
  onClickOutside: React.EventHandler<any>
  refs: Array<React.RefObject<HTMLElement>>
}

export interface ClickOutsideProps extends ClickOutsideConfig {
  children: React.ReactElement
}

interface ClickOutsideRenderProps extends ClickOutsideConfig {
  children: React.ReactElement
  scope?: React.RefObject<HTMLElement>
}

const isEventSource = (ref: React.RefObject<HTMLElement>, event: Event) =>
  ref.current && event.target instanceof HTMLElement
    ? ref.current.contains(event.target)
    : false

export const useClickOutside = ({
  refs = [],
  onClickOutside,
}: ClickOutsideConfig) => {
  const handler: React.EventHandler<any> = event => {
    if (onClickOutside && !refs.find(ref => isEventSource(ref, event))) {
      onClickOutside(event)
    }
  }

  const options = { capture: true }

  useEventListener({ event: 'click', handler, options })
  useEventListener({ event: 'touchend', handler, options })
}

/* RENDER PROP */

// TODO: remove component ClickOutside and uncomment bellow

// export const ClickOutside = React.forwardRef<
//   HTMLElement,
//   ClickOutsideRenderProps
// >(({ children, ...props }, forwardedRef) => {
//   const scope = props.scope || (forwardedRef as React.RefObject<HTMLElement>)

//   useClickOutside({ ...props, refs: [scope, ...props.refs] })
//   debugger

//   return React.cloneElement(children, { ...children.props, ref: scope })
// })
